module.exports = __webpack_public_path__ + "static/media/logo.ccbaa12b.png";